import React from 'react';
import { IconProps } from '.';

const SvgPinColor = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <g clipPath='url(#PinColor_svg__a)'>
        <path fill={color} d='m4.941 15.247 5.774-8.69.967.636-5.378 8.082-1.363-.028Z' />
        <path fill='#F1F1F3' d='M4.941 15.31 10.715 24l.967-.635-5.378-8.09-1.363.036Z' />
        <path fill={color} d='m11.678 7.19-.958-.637L8.45 9.968l.958.637 2.271-3.414Z' />
        <path fill='#FF4177' d='M13.165 10.377a5.188 5.188 0 1 0 0-10.377 5.188 5.188 0 0 0 0 10.377Z' />
        <path fill='#fff' d='M15.58 4.398a.868.868 0 1 0 0-1.737.868.868 0 0 0 0 1.737Z' />
      </g>
      <defs>
        <clipPath id='PinColor_svg__a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPinColor;
